import React from "react";
import { NavLink } from "react-router-dom";

const TABS = [
  { to: "/analytics-usage", label: "Dashboard", end: true },
  { to: "/analytics-usage/users", label: "Connected Users", end: false },
  { to: "/analytics-usage/map", label: "Users Map", end: false },
  { to: "/analytics-usage/devices", label: "Devices", end: false },
];

const AnalyticsSubNav = () => (
  <nav className="analytics-subnav" aria-label="App Analytics sections">
    {TABS.map(({ to, label, end }) => (
      <NavLink
        key={to}
        to={to}
        end={end}
        className={({ isActive }) => `analytics-subnav__link${isActive ? " active" : ""}`}
      >
        {label}
      </NavLink>
    ))}
  </nav>
);

export default AnalyticsSubNav;
